



import Vue from "vue";
export default Vue.extend({
  props: {
    isChecked: {
      type: Boolean,
      required: true,
    },
    customIconClass: {
      type: String,
      required: false
    }
  },
  computed: {
    iconClass():String {
      return this.isChecked ? "icon-randomizer-check" : this.currentIcon;
    },
    currentIcon():String {
      return this.customIconClass ? this.customIconClass : "dot";
    }
  },
});
